<template>
  <div class="text-center py-16 px-4 bg-white dark:bg-gray-800/50 rounded-3xl border-2 border-dashed border-gray-200 dark:border-gray-700">
    <div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-50 dark:bg-gray-700/50 mb-6">
      <component :is="icon" class="w-10 h-10 text-gray-400" />
    </div>
    <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
      {{ title }}
    </h3>
    <p class="text-gray-600 dark:text-gray-400 max-w-sm mx-auto mb-8 text-sm leading-relaxed">
      {{ message }}
    </p>
    <div v-if="actionText" class="flex justify-center">
      <button
        v-if="!actionLink"
        @click="$emit('action')"
        type="button"
        class="inline-flex items-center px-6 py-3 bg-blue-600 dark:bg-blue-500 text-white font-bold rounded-xl hover:bg-blue-700 dark:hover:bg-blue-600 transition-all duration-300 shadow-lg shadow-blue-500/30 active:scale-95"
      >
        {{ actionText }}
      </button>
      <router-link
        v-else
        :to="actionLink"
        class="inline-flex items-center px-6 py-3 bg-blue-600 dark:bg-blue-500 text-white font-bold rounded-xl hover:bg-blue-700 dark:hover:bg-blue-600 transition-all duration-300 shadow-lg shadow-blue-500/30 active:scale-95"
      >
        {{ actionText }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  title: string
  message: string
  actionText?: string
  actionLink?: string
}>()

defineEmits(['action'])
</script>












